/*
 * @Desc: 单页 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: lc
 * @LastEditTime: 2023-06-06 17:02:11
 */
import request from "@/utils/request";
const index = {
    // 列表
    list (query) {
        return request({
            url: "/pages/list",
            method: "get",
            params: query
        });
    },
    // 新增
    create (data) {
        return request({
            url: "/pages/create",
            method: "post",
            data
        });
    },
    // 编辑
    edit (data) {
        return request({
            url: "/pages/edit",
            method: "post",
            data
        });
    },
    // 详情
    detail (query) {
        return request({
            url: "/pages/detail",
            method: "get",
            params: query
        });
    },
    // 删除
    remove (data) {
        return request({
            url: "/pages/remove",
            method: "post",
            data
        });
    },
};
export default index;